<div class="container">
  <div class="image">
    <img [src]="imageURL()" />
  </div>

  <div class="close" (click)="close()">X</div>
</div>
